<template>

    <div>

        <v-card class="pa-3 yellow lighten-3" dense>       
              
         
            <v-toolbar class="py-0 my-0 mb-4" color="pa-3 yellow lighten-3">
                
                    <v-spacer></v-spacer> 

                    <v-toolbar-title class="my-0 py-0 text-center" style="color: red; font-weight: bold;">
                        EI079 Número {{ datos.numero }}
                    </v-toolbar-title>

                    <v-spacer></v-spacer> 
                    
                    <div>
                        <v-btn icon @click="imprimir(datos.numero)" color="primary">
                        <v-icon>mdi-printer</v-icon>
                        </v-btn>
                    </div>

            </v-toolbar>
           
              

              
            <v-card class="pa-2 yellow lighten-4 mb-4" dense >
                                
                <v-row  dense  class="py-0 my-0" >

                    <v-col cols="4" sm="4" md="4"  dense>
                        Fecha EI079: {{ datos.fecha }}
                    </v-col>
                    <v-col cols="4" sm="4" md="4" dense>
                        Cliente: {{ datos.nombre }}
                    </v-col>
                    <v-col  cols="4" sm="4" md="4"  dense class="text-right">
                        Resp. Comercial: {{ datos.usuario }}
                    </v-col>

                </v-row>  
                
                                
                
            </v-card>    

            <div></div>

            <v-card class="pa-2 yellow lighten-4 mb-4" dense >
                <v-row>
                    <v-col cols="12" sm="12" md="12">

                        <v-data-table
                            :headers="headers"
                            :items="desserts"
                            class="elevation-1"
                            dense
                            :items-per-page.sync="itemsPerPage"
                            :footer-props="{
                            itemsPerPageText: 'Items por página',
                            }"

                        ></v-data-table>

                    </v-col>
                </v-row>
                
            </v-card>

                <div></div>               
                <v-card class="pa-2 yellow lighten-4 mt-4" dense >
                        <v-row>

                        </v-row>
                        <v-row>
                            <v-col cols="auto">
                                Observación: {{ datos.observa }}
                            </v-col>
                        </v-row>
                
                </v-card>
           

            </v-card>

    </div>


  
  </template>
  
  <script>

  import readXlsFile from "read-excel-file";
  import Axios from '../../../axios-auth-sistemas';

  import BuscadorClientes from "../../Comercial/BuscadorClientes.vue"; 


  import moment from "moment";

  import jsPDF from "jspdf"; 
  import "jspdf-autotable";




  
  export default {

    name:'EI079Link',

    data() {
      return {
        headers: [

          { text: "Item", value: "item",width:"8%", align: "left",sortable: false, },  
          { text: "Articulo", value: "articulo",width:"12%", align: "left",sortable: false, },
          { text: "Detalle", value: "detalle",width:"20%", align: "left",sortable: false, },
          { text: "Cant.", value: "cantidad",width:"5%", align: "left",sortable: false, },
          { text: "unidad", value: "un",width:"5%", align: "left",sortable: false, },         
          { text: "Fecha Nec.", value: "fechan",width:"15%", align: "left",sortable: false, },
          { text: "Tipo", value: "tipo",width:"10%", align: "left",sortable: false, }, 
          { text: "Cant.Pres.", value: "cantp",width:"5%", align: "left",sortable: false, },         
          { text: "Pre.Pres.", value: "preciop",width:"5%", align: "left",sortable: false, }, 
          { text: "Moneda", value: "moneda",width:"5%", align: "left",sortable: false, }, 
          { text: "Destino", value: "destino",width:"10%", align: "left",sortable: false, }, 
          { text: "Ins/Prot", value: "ins",width:"5%", align: "left",sortable: false, }, 
          { text: "Seguim.", value: "seguimiento",width:"5%", align: "left",sortable: false, }, 
         // { text: "Nota", value: "nota",width:"10%", align: "left",sortable: false, }, 
         // { text: "id", value: "id",width:"5%", align: "left",sortable: false, },
          
         // { text: "Acciones", value: "acciones",width:"5%", align: "left",sortable: false, },

        ],

        
        excelData: [],
        codigoCli:'',
        nombreCli:'',
        cuitCli:'',
        showBuscadorCli:false,
        showFlags:'',
        CodigoSele:'',
        editMode:false,
        dessertAux:[],
        vAlert:'',
        activar:false,
        validacionExitosa: true, 
        fileInput:'',
        dialogCorreo:false,
        direcciones: [],
        direccion: "",
        correos: "",
        mailSel:"",
        vNumRto:'',
        vRtoGral:'',
        datos:{
            codigo:'',
            detalle:'',
            numero:'',
            fecha:'',
            usuario:'',
            ordencompra:'',
            envio:'',
            cantcamion:'',
            id:''

        },
        desserts:[],
        visible:true,
        itemsPerPage:-1,

        desserts3:[],


      };
    },


    computed: {

        show: {
            get() {        
    
            return this.visible;
            },
        } 

    },
    watch: {
        
       
    } ,   

    mounted() {

       console.log("estoy en ei079 link",  this.$route.query.codgral)
        this.vRtoGral = this.$route.query.codgral;
        this.cargarEI079(this.vRtoGral);

    },


    methods: { 

        salir(){
            this.visible=false;
        },

       cargarEI079(id1){

            console.log("estoy en cargarEI079")
            console.log("id ingresado es", id1)
            Axios
            .get("/ComercialVentas/MostrarEI079MAIL?", {
            params: {
                id: id1                 
            },
            })
            .then((r) => { 

                console.log("datos",r.data)

                const fechaPedido = moment(r.data.fecha); // Formato ISO reconocido
                let fechaFormateada =  fechaPedido.format('DD/MM/YYYY');
                    

                this.datos.codigo = r.data.codCliente;
                this.datos.nombre = r.data.codCliente == null || r.data.codCliente == '' ?  r.data.nombreCliente : r.data.codCliente + ' - ' + r.data.nombreCliente;
                this.datos.numero = r.data.nroPedido;
                this.datos.fecha = fechaFormateada;
                this.datos.usuario = r.data.solicito;
                this.datos.observa = r.data.observacion;
                this.datos.id = r.data.idCab;
               

                
                r.data.detalles.forEach(element => {

                    let fechaFormateada = "";

                    if (element.fechaNec) {
                        const fechaMoment = moment(element.fechaNec); // Formato ISO reconocido
                        fechaFormateada = fechaMoment.format('DD/MM/YYYY');
                        
                    }

                    
                    console.log("fecha momento", fechaFormateada)

                    this.desserts.push({


                        item: element.item==null? "": element.item,
                        articulo: element.articulo==null? "": element.articulo,
                        detalle: element.detalle==null? "": element.detalle ,
                        cantidad: element.cantidad > 0 ? this.formatearNumbero(element.cantidad) : "" ,
                        un: element.cantidad > 0 ? element.un==null? "": element.un : "",
                        moneda: element.cantidad > 0 ? element.moneda==null? "": element.moneda : "",
                        cantp: element.cantidad > 0 ? element.cantidadp==null? "":  this.formatearNumbero(element.cantidadp) : "",
                        preciop:element.cantidad > 0 ? element.preciop==null? "": this.formatearNumbero(element.preciop) : "",
                        ins: element.cantidad > 0 ? element.ins==null? "": element.ins : "",
                        seguimiento:element.cantidad > 0 ? element.seguimiento==null? "": element.seguimiento : "" ,
                        id: element.renglon,
                        fechan: element.cantidad > 0 ? element.fechaNec==null? "": fechaFormateada : "",
                        destino: element.cantidad >  0 ? element.idDestino=="2" ? "VENTAS": "STOCK":"",
                        tipo: element.cantidad > 0 ? element.tipo==null? "": element.tipo : "",


                    });


                });

                

            })
            .catch((error) => {
                console.log("no muestra el remmito cuando hace link")      
                
                            
            }); 



       },


       formatearNumbero(value) {
            if (value == null || value === "") return "";
            return new Intl.NumberFormat("es-AR", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(value);
        },



        imprimir(id){

            let self = this;

            self.desserts3=[];

            let viit=0;
            let vvren=0;
            let fechaHoy="";



            if (id == "") {
                this.$swal({
                    icon: "error",
                    html: `
                    <div style="font-size: 18px;">
                        <strong>No se puede imprimir una EI079 que no fue guardada</strong><br>
                    
                    </div>
                    `
                });
                return;
            }



       
            Axios
            .get("/ComercialVentas/ImprimirEI079?", {
            params: {
                id: id               
                },
            })
            .then((r) => { 
                console.log("datos para imprimir", r.data.detalles) 
                console.log("datos para imprimir", r.data)           
                 
                if(r.data.length === 0){

                     this.$swal({
                            title: "",
                            text: "No existen datos para imprimir",
                            icon: "info"
                        });                                
                        return;
                };
                
                let fechaPedidoFormateada = "";

                const fechaPedido = moment(r.data.fecha); 
                        fechaPedidoFormateada = fechaPedido.isValid()
                            ? fechaPedido.format('DD/MM/YYYY')
                            : "Fecha inválida";

                                    
                console.log("fecha pedido", fechaPedidoFormateada);

                r.data.detalles.forEach(element => {

                    let fechaFormateada = "";

                    if (element.fechaNec) {
                        const fechaMoment = moment(element.fechaNec); // Formato ISO reconocido
                        fechaFormateada = fechaMoment.isValid()
                            ? fechaMoment.format('DD/MM/YYYY')
                            : "Fecha inválida";
                    }

                    
                    console.log("fecha necesidad", fechaFormateada)

                    self.desserts3.push({
                            item: element.cantidad > 0? element.item: "",
                            articulo: element.articulo,
                            detalle: element.detalle,
                            cantidad:  element.cantidad > 0 ? this.formatearNumbero(element.cantidad) : "",
                            cantp: element.cantidad > 0 ? this.formatearNumbero(element.cantidadp) : "" ,
                            preciop:  element.cantidad > 0 ? this.formatearNumbero( element.preciop) : "" ,
                            seguimiento: element.cantidad > 0 ? element.seguimiento : "" ,
                            ins: element.cantidad > 0 ?  element.ins : "" ,
                            un: element.cantidad > 0 ?   element.un : "" ,
                            tipo: element.cantidad > 0 ?   element.tipo : "" ,
                            moneda:element.cantidad > 0 ? element.moneda : "" ,
                            fechan:element.cantidad > 0 ?  fechaFormateada : "" ,
                            fechap: element.cantidad > 0 ?   fechaPedidoFormateada : ""  ,
                            destino: element.cantidad > 0 ? ( element.idDestino == '1'?  'STOCK' : 'VENTAS') : "",
                            pedido: element.nroPedido,
                            renglon: element.renglon,
                            fecha: fechaPedidoFormateada,
                            comercial: r.data.solicito ,
                            cliente: r.data.codCliente == null? r.data.nombreCliente : r.data.codCliente + ' - ' + r.data.nombreCliente,
                            observacion:  r.data.observacion 
                            
                    })                


                });


                self.generarPDF();


            })
            .catch((error) => {
                console.log("error no pasaaaa")      
                
                            
            }); 




            // fechaHoy = moment().format('DD/MM/YYYY')

            // self.desserts.forEach(element => {

            //             if(element.cantidad > 0 ){
            //                 viit = viit + 1;
            //             };
            //             vvren = vvren + 1;
            //             self.desserts3.push({
            //                 item: element.cantidad > 0? viit:"",
            //                 articulo: element.articulo,
            //                 detalle: element.detalle,
            //                 cantidad:  element.cantidad > 0 ?  element.cantidad : "",
            //                 cantp: element.cantidad > 0 ?  element.cantp : "" ,
            //                 preciop:  element.cantidad > 0 ? element.preciop : "" ,
            //                 seguimiento: element.cantidad > 0 ? element.seguimiento : "" ,
            //                 ins: element.cantidad > 0 ?  element.ins : "" ,
            //                 un: element.cantidad > 0 ?   element.un : "" ,
            //                 tipo: element.cantidad > 0 ?   element.tipo : "" ,
            //                 moneda:element.cantidad > 0 ? element.moneda : "" ,
            //                 fechan:element.cantidad > 0 ?  element.fechan : "" ,
            //                 fechap: element.cantidad > 0 ?   element.fechap : ""  ,
            //                 destino: element.cantidad > 0 ? ( element.idDestino == '1'?  'STOCK' : 'VENTAS') : "",
            //                 pedido: self.vRtoGral,
            //                 renglon: vvren,
            //                 fecha: fechaHoy,
            //                 comercial: self.$store.state.nombre,
            //                 cliente:  self.datos.nombre,
            //                 observacion: self.datos.observa,
                            
            //             })
            // });

            // console.log("arra", self.desserts3)

          //  self.generarPDF();

       

        },




        generarPDF(){
           let self = this; 

           console.log("detalle a imprimir",self.desserts3);
         

          
            var vm = this;      
            var columns = [
            {title: "IT", dataKey: "item"},
            {title: "Código", dataKey: "articulo"},            
            {title: "I-P", dataKey: "ins"},
            {title: "Critico", dataKey: "seguimiento"},
            {title: "Cant.", dataKey: "cantidad"},
            {title: "Un.", dataKey: "un"},
            {title: "Descripcion", dataKey: "detalle"},
            {title: "Tipo", dataKey: "tipo"},
            {title: "Mon.", dataKey: "moneda"},
            {title: "Cant. Pres.", dataKey: "cantp"},  
            {title: "Precio Unit. Pres.", dataKey: "preciop"},                            
            {title: "Fecha Nec.", dataKey: "fechan"},
            {title: "Destino", dataKey: "destino"},
            

            ];
            var doc = new jsPDF();
            doc.setLineWidth(0.5);
            doc.line(10, 11, 200, 11);           
            doc.line(10, 11, 10, 41);
            doc.line(165, 28, 200, 28);
           // doc.line(165, 33, 200, 33);
            doc.addImage(
                "/9j/4AAQSkZJRgABAQEBLAEsAAD/2wBDAAgGBgcGBQgHBwcJCQgKDBQNDAsLDBkSEw8UHRofHh0aHBwgJC4nICIsIxwcKDcpLDAxNDQ0Hyc5PTgyPC4zNDL/2wBDAQkJCQwLDBgNDRgyIRwhMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjL/wAARCABHAEUDASIAAhEBAxEB/8QAHwAAAQUBAQEBAQEAAAAAAAAAAAECAwQFBgcICQoL/8QAtRAAAgEDAwIEAwUFBAQAAAF9AQIDAAQRBRIhMUEGE1FhByJxFDKBkaEII0KxwRVS0fAkM2JyggkKFhcYGRolJicoKSo0NTY3ODk6Q0RFRkdISUpTVFVWV1hZWmNkZWZnaGlqc3R1dnd4eXqDhIWGh4iJipKTlJWWl5iZmqKjpKWmp6ipqrKztLW2t7i5usLDxMXGx8jJytLT1NXW19jZ2uHi4+Tl5ufo6erx8vP09fb3+Pn6/8QAHwEAAwEBAQEBAQEBAQAAAAAAAAECAwQFBgcICQoL/8QAtREAAgECBAQDBAcFBAQAAQJ3AAECAxEEBSExBhJBUQdhcRMiMoEIFEKRobHBCSMzUvAVYnLRChYkNOEl8RcYGRomJygpKjU2Nzg5OkNERUZHSElKU1RVVldYWVpjZGVmZ2hpanN0dXZ3eHl6goOEhYaHiImKkpOUlZaXmJmaoqOkpaanqKmqsrO0tba3uLm6wsPExcbHyMnK0tPU1dbX2Nna4uPk5ebn6Onq8vP09fb3+Pn6/9oADAMBAAIRAxEAPwD3+qeq6rY6Hpdxqep3MdtZ26b5ZX6KP5kk4AA5JIAyTRquq2Oh6XcanqdzHbWdum+WV+ij+ZJOAAOSSAMk18kfEz4mX3j/AFQIgkttFt3JtbQnknp5kmOC5HbooOB1JYA7DVf2kNebVLg6PpWmpp+/EAu43aXb6sVcDJ64HTOMnGTT/wCGjvGH/QN0P/vxN/8AHa8fooA9g/4aO8Yf9A3Q/wDvxN/8dru9N+LOvaX4ObxR4ytNNtoLtCNI061jdLi9bg7yWdgkQBHJHIIPdQ/jGlaVY+FdLt/EfiO2jubq4TzNI0aXpOO1xOOogB+6vWQjsoJOH4n8T6p4u1ybV9Xn824k4VV4SJB0RB2UZP5kkkkkgHpH/DR3jD/oG6H/AN+Jv/jtdP4C+Pd/rnii00fX9PsYo76VYYbi0Ei+W5BCgqS+7c2xeq4yScjp88V6p4L0qx8FeKvDw1q2juvE1/e2yw6fL93TYndR5sw/57lTlE/gyGbnaKAPquiiigD5s/aQ1W+bxVpmjm5k/s9LJboW44XzWeRS59TtUAZ6c4xk58Tr2D9o7/koen/9gqP/ANGy14/QB9H/AAt+Fvg3xH8ONJ1bVtG+0X0/neZL9qmTdtmdRwrgDgAcCu0g+DHw+triKdPDsZeNw6iS5mdSQc8qzkMPYgg96+VLHxZ4k0yzjs7DxBqtpax52QwXskaLkknCg4GSSfxqx/wnfjD/AKGvXP8AwYzf/FUAfVeq/CfwVrmqXGp6npElzeXD75ZXvbjLH/vvAAGAAOAAAMAVy/i/4IeD/wDhFdRn0bSru31C2t5J4Ba3EkjTOqMVjKuWyC2OAAemDXgEHjTxtdXEVvb+JfEE08rhI447+ZmdicAABskk8Yr6D0fwz4k8K/DHxDquv+ItVu9dk0q4dUe/kkSyxGzAL82DICAS46YwvGSwB4x9uT4X/uNOkgn8ZHi6uwqyx6WO8Mecq8x6O/IUZRcncaw/Bc8118S/D1xcSyTTy6xbPJJIxZnYzKSSTySTzmubroPAn/JQ/DX/AGFbX/0atAH2/RRRQB8wftHf8lD0/wD7BUf/AKNlrx+vYP2jv+Sh6f8A9gqP/wBGy14/QAVJBBNdXEVvbxSTTyuEjjjUszsTgAAckk8Yr6j+EHizw3pnwt0azv8AxBpVpdR+fvhnvY43XM8hGVJyMgg/jXcf8J34P/6GvQ//AAYw/wDxVAHF/Cb4TQ+DbdNY1hI5vEEqcDIZbNSOVU9C5HDMP90cZLdp47/5J54l/wCwVdf+imo/4Tvwf/0Neh/+DGH/AOKrL8U+JdB1nwL4nt9L1vTb6ddHu3aO1uklYL5TDJCknGSBn3FAHxpXQeBP+Sh+Gv8AsK2v/o1a5+ug8Cf8lD8Nf9hW1/8ARq0Afb9FFFAHzB+0d/yUPT/+wVH/AOjZa8fr6H+Nfw78VeLvGVnf6HpX2u1j09IWf7RFHhxJISMOwPRh+decf8KS+If/AEL3/k7b/wDxygDH+Hfhuz8XeO9N0O/knjtbrzd7wMA42xO4wSCOqjtXs+pfAz4f6Rv+3a1rkWy0mvW/eRtiGHb5jcQnpvXjqc8A81gfC34W+MvDnxH0nVtW0b7PYwed5kv2qF9u6F1HCuSeSBwK9j8U6BfaxrmmXFosYS0t5H3SNhTKt1ZzxxnGSA3kONwB29cHgEA8vHwf+G5t3lOreJ0dHVPs0kBS4YsCRtgNuJGBCucqpGEc/wADY2NE8K+DdK8NX1jovifxB9j1J5rW8trexjmumKDZIjoLUzIF3AcgBTIDwXGe01uTWdY06KRfCs4jgu4y1vJfpBeFCHV3geKTajDcvWQb181SFBBbn10bxU+k28epWOq3kIluIIZIdUii1azgMaLExlQxxyZaNmdCzctESXKGgDm2+Cfw5TS9O1J9f1lLTUnhSzdpowZmmx5YVTFnJznGOBknABxsW/wo0b4eXdn4g0TUNSN4t7aW2LryJVMc1xHFIBmLKkq7DcpB5POCQdCTwx4r8R2UOnahPHYW1vo/2TzL2EXjyyzoVkbcs4zLHGFj80qNxkmIUK2K6DXZL6XwfpzanDHDfjU9NW4WI5QuL2EFk5J2EjK55wRkA5AAOsooooAKKKKAK99ZRahZyWszzpG+MmCd4XGCDw6EMOnY89OlY/8Awhul/wDP1rn/AIPb3/49RRQAf8Ibpf8Az9a5/wCD29/+PUf8Ibpf/P1rn/g9vf8A49RRQAf8Ibpf/P1rn/g9vf8A49QPBmkebDJI+qzeTKkyJPrF3Km9GDqSjSlThlB5B6UUUAdBRRRQB//Z",
                "JPEG",
                15,
                15,
                22,
                22
            );
            doc.setFontSize(13);
            doc.text("SOLICITUD DE MATERIALES EI079" , 65, 20);
            doc.setFontSize(12);
            doc.text("N° PEDIDO " + vm.desserts3[0].pedido  , 72, 26);
            doc.setFontSize(8);
            doc.text("Descripción: " +vm.desserts3[0].cliente , 42, 33);
            doc.setFontSize(14);
            //doc.text("OT N°: " + this.$store.state.otrabajo , 166, 20);
            doc.line(40, 11, 40, 41);
            doc.setFontSize(10);
            doc.text("Fecha: " +vm.desserts3[0].fecha, 166, 20);           
            doc.setFontSize(11);
            doc.text("EI079 Rev. 2" , 170, 38);
            doc.line(40, 11, 40, 41);
            doc.line(165, 11, 165, 41);
            doc.line(10, 41, 200, 41);
            doc.line(200, 11, 200, 41);
            doc.setFontSize(10);
        
        
            doc.autoTable(columns, this.desserts3, {
            theme: 'grid',     
            startY: 45,
            margin: { top: 25, left: 10 , right: 10},
            styles: { fontSize: 7 }
            
            });

        

            var finalO =  doc.autoTable.previous.finalY + 30;

            if (finalO >= 285) {
                doc.addPage();
                finalO = 0;
            }

            doc.setFontSize(11);
          //  doc.text("Responsable Tecnico:  "+ vm.desserts3[0].tecnico, 10,finalO+ 45);
            doc.text("Responsable Comercial:  "+ vm.desserts3[0].comercial, 10,finalO + 51);

            if (vm.desserts3[0].observacion != ""){

                doc.text("Observación:  "+ vm.desserts3[0].observacion, 10,finalO  + 60);

            }

            const pageCount = doc.internal.getNumberOfPages();

            for (var i = 1; i <= pageCount; i++) {
                doc.setPage(i);
                doc.text(
                "Página " + String(i) + " de " + String(pageCount),
                210 - 20,
                297 - 10,
                null,
                null,
                "right"
                );
            }

            doc.save('table.pdf');



        },
       




    },
  };
  </script>
  
  <style scoped>
  
  </style>
  